import React from 'react';
import { Button } from 'tfc-components';

import Icon from 'components/atoms/Icon';

interface ModalViewImageChatbotProps {
  onClose?: () => void;
  imgUrl: string,
}

const ModalViewImageChatbot: React.FC<ModalViewImageChatbotProps> = ({ imgUrl, onClose }) => (
  <div className={`m-chatMessage_imgModal${imgUrl ? ' open' : ' close'}`} onClick={onClose}>
    <Button variant="text" type="button" extendClasses="m-chatMessage_imgModal_close" onClick={onClose}>
      <Icon iconName="whiteCircleClose" size="24" />
    </Button>
    <img src={imgUrl} alt={imgUrl} onClick={(e) => e.stopPropagation()} />
  </div>
);

export default ModalViewImageChatbot;
